var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375011 6.75H1.50001V5.24999C1.50001 2.35512 3.85509 0 6.75 0C9.64491 0 12 2.35512 12 5.24999V6.75H13.125C13.3323 6.75 13.5 6.91773 13.5 7.12501V16.5C13.5 17.3273 12.8273 18 12 18H1.49998C0.672714 18 0 17.3273 0 16.5V7.12501C0 6.91773 0.16773 6.75 0.375011 6.75ZM5.62718 14.5836C5.61547 14.6894 5.6495 14.7956 5.72055 14.8751C5.7916 14.9546 5.89342 15 5.99998 15H7.49999C7.60655 15 7.70836 14.9546 7.77941 14.8751C7.85046 14.7957 7.88453 14.6895 7.87279 14.5836L7.63622 12.4563C8.02037 12.1769 8.24998 11.7349 8.24998 11.25C8.24998 10.4227 7.57726 9.74999 6.74996 9.74999C5.92267 9.74999 5.24995 10.4227 5.24995 11.25C5.24995 11.7349 5.47956 12.1769 5.86371 12.4563L5.62718 14.5836ZM3.75001 6.75H9.74999V5.24999C9.74999 3.59582 8.40417 2.25 6.75 2.25C5.09583 2.25 3.75001 3.59582 3.75001 5.24999V6.75Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.7ccb57d366d38eae5f9cb8f93291709c.svg";
export { ForwardRef as ReactComponent };